import { render, staticRenderFns } from "./NoticeboardPreview.vue?vue&type=template&id=5f1cf208&scoped=true&"
import script from "./NoticeboardPreview.vue?vue&type=script&lang=js&"
export * from "./NoticeboardPreview.vue?vue&type=script&lang=js&"
import style0 from "./NoticeboardPreview.vue?vue&type=style&index=0&id=5f1cf208&prod&lang=css&"
import style1 from "./NoticeboardPreview.vue?vue&type=style&index=1&id=5f1cf208&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1cf208",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QCardActions,QBtn});qInstall(component, 'directives', {ClosePopup});
